import { AnswerResultEnum, CompletionResultStatusEnum } from '@/swagger/constants/quiz-enums';

export const it = {
  quiz: {
    startDialog: {
      start: 'Inizia il quiz',
      resume: 'Riprendi il quiz',
      restart: 'Ripeti il quiz',
      questions: '{{questions}} Domande',
      duration: '{{time}} min',
      credits: '{{credits}} Crediti',
      title: 'Quiz: {{quizName}}',
      colleaguesHint: {
        singular: 'Un altro tuo collega ha già fatto il quiz, non restare indietro!',
        plural: 'Oltre {{colleagues}} colleghi hanno già fatto il quiz, non restare indietro!',
      },
      errors: {
        noCredits: 'Non hai crediti sufficienti per iniziare il quiz.',
      },
    },
    confirmExitFromQuizDialog: {
      title: 'Esci dal contenuto',
      description:
        'Uscendo dal quiz, avrai la possibilità di completarlo in un secondo momento, senza perdere i tuoi progressi.',
      adminDescription:
        'Se chiudi il quiz adesso, non potrai riprendere dal punto in cui hai interrotto, ma potrai rifarlo tutte le volte che vuoi dall’inizio',
      confirm: 'Esci',
      cancel: 'Annulla',
    },
    confirmRestartQuizDialog: {
      title: 'Pronto per un nuovo tentativo?',
      description:
        'Ripetere il quiz ti aiuta a migliorare: il nuovo tentativo richiede {{credits}} crediti.',
      confirm: 'Ripeti quiz',
      cancel: 'Annulla',
    },
    dynamicQuiz: {
      exit: 'Esci dal quiz',
      quizTitle: 'Quiz:\n{{quizName}}',
      stepXonY: 'Passo {currentStep} di {totalSteps}',
      answerFeedbackLabels: {
        [AnswerResultEnum.CORRECT]: 'Risposta corretta!',
        [AnswerResultEnum.INCORRECT]: 'Risposta errata.',
        [AnswerResultEnum.PARTIALLY]: 'Risposta parzialmente corretta.',
      },
      quizResult: {
        [CompletionResultStatusEnum.FULL_SUCCEEDED]: {
          title: 'Gran Risultato!',
          label: 'Tu e altri {{total}} colleghi avete superato il punteggio medio di {{score}}%!',
          description:
            'Vuoi migliorare ancora? Ripeti il quiz: ad ogni nuovo tentativo troverai domande diverse per rafforzare le tue competenze.',
        },
        [CompletionResultStatusEnum.PARTIALLY_SUCCEEDED]: {
          title: 'Ben fatto!',
          label:
            'Sei in linea con la maggior parte dei tuoi colleghi che hanno ottenuto in media un punteggio del {{score}}%',
          description:
            'Vuoi migliorare ancora? Ripeti il quiz: ad ogni nuovo tentativo troverai domande diverse per rafforzare le tue competenze.',
        },
        [CompletionResultStatusEnum.NOT_SUCCEEDED]: {
          title: 'Perfetto momento per migliorare!',
          label:
            'Il tuo risultato è sotto la media dei colleghi: un’ottima occasione per migliorare!',
          description:
            'Vuoi migliorare ancora? Ripeti il quiz: ad ogni nuovo tentativo troverai domande diverse per rafforzare le tue competenze.',
        },
        [CompletionResultStatusEnum.SUCCEEDED]: {
          title: 'Quiz completato!',
          label: '',
          description:
            'Il risultato mostra il tuo livello attuale, è un ottimo punto di partenza per consolidare ciò che già conosci e individuare eventuali aree di miglioramento.',
        },
        completedQuiz: 'Hai completato il quiz',
        correctAnswers: '{{correct}} su {{total}} risposte corrette',
        cta: {
          next: 'Chiudi',
          restart: 'Ripeti il quiz',
        },
      },
    },
  },
};
